<template>
  <BaseDetails>
    <template #head>
      <router-link :to="{ name: 'customer' }" style="text-decoration: none">
        <h4 class="text-capitalize font-weight-bold text_color--text">
          {{ customerModule.customer }}
        </h4>
      </router-link>
      <span class="mx-3">/</span>
      <h4 class="text-capitalize font-weight-bold primary--text">details</h4>
    </template>
    <template #content>
      <v-row class="ma-0">
        <v-col cols="12" md="3" lg="3" class="pa-1">
          <section>
            <v-card elevation="0" class="mb-4">
              <v-row
                no-gutters
                v-if="customerDetail.customer_details"
                class="pa-4"
              >
                <v-col cols="4" v-if="customerDetail.profile_image">
                  <img
                    :src="customerDetail.profile_image"
                    height="100px"
                    width="100px"
                  />
                </v-col>
                <v-col cols="4" v-else>
                  <img :src="driverImage" height="100px" width="100px" />
                </v-col>
                <v-col cols="8" class="py-2">
                  <div>
                    <h4
                      class=""
                      v-if="customerDetail.customer_details.company_name"
                    >
                      {{ customerDetail.customer_details.company_name }}
                    </h4>
                    <div class="text-subtitle-1 font-weight-bold d-flex">
                      <h5
                        class="text_color--text"
                        v-if="customerDetail.customer_details.customer_name"
                      >
                        {{ customerDetail.customer_details.customer_name }}
                      </h5>
                    </div>
                  </div>
                  <v-row no-gutters>
                    <v-col cols="6">
                      <h5 class="text_color--text">
                        {{ configurationModule.branch }}
                      </h5>
                    </v-col>
                    <v-col cols="6">
                      <h5
                        class="text_color--text"
                        v-if="customerDetail.customer_details.branch"
                      >
                        {{ customerDetail.customer_details.branch }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            <v-card elevation="0" class="my-4">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>{{ customerModule.customer }} Details</h6>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-icon
                      class="primary--text"
                      v-if="permissions.change"
                      @click="showCustomerForm = true"
                      small
                      >mdi-pencil</v-icon
                    >
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle>
                <div v-if="customerDetails">
                  <div
                    v-for="(value, key, index) in customerDetails"
                    :key="index"
                  >
                    <v-row
                      no-gutters
                      class="pt-1 px-2"
                      v-if="!['id', 'branch'].includes(key)"
                    >
                      <v-col cols="5" v-if="key">
                        <h5 class="text_color--text text-capitalize">
                          {{ key.replace(/_/g, "  ") }}
                        </h5>
                      </v-col>
                      <v-col cols="7">
                        <h5
                          v-if="
                            key == 'email_notification' ||
                            key == 'whatsapp_notification'
                          "
                        >
                          <v-icon small :color="value ? 'success' : 'error'">
                            {{
                              value ? "mdi-check-circle" : "mdi-close-circle"
                            }}
                          </v-icon>
                        </h5>
                        <h5 v-else>{{ value }}</h5>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-subtitle>
            </v-card>

            <v-card elevation="0" class="my-3 h-100">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Assigned {{ tripPlanningModule.tagPlural }}</h6>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <!-- <v-icon class="primary--text">mdi-plus</v-icon> -->
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <div
                v-if="
                  customerDetail &&
                  customerDetail.assigned_tag &&
                  customerDetail.assigned_tag.length > 0
                "
                class="px-4 py-2"
              >
                <v-chip-group column>
                  <v-chip
                    small
                    close
                    close-icon="mdi-close"
                    v-for="(zone, index) in customerDetail.assigned_tag"
                    :key="index"
                    @click:close="deleteDriverZones(zone.id, index)"
                    >{{ zone.name }}</v-chip
                  >
                </v-chip-group>
              </div>
              <v-card-subtitle
                v-else
                style="height: 240px"
                class="d-flex justify-center align-center"
              >
                <h5 class="font-weight-bold text_color--text">
                  There is no document available.
                </h5>
              </v-card-subtitle>
              <v-card-subtitle
                style="max-height: 240px"
                class="overflow-y-auto"
              >
              </v-card-subtitle>
            </v-card>
          </section>
        </v-col>
        <v-col cols="12" md="6" lg="6" class="pa-1">
          <section>
            <div
              v-if="customerDetail && customerDetail.customer_analytics"
              class="pb-4 px-2"
            >
              <v-row no-gutters>
                <v-col
                  v-for="(
                    value, key, index
                  ) in customerDetail.customer_analytics"
                  :key="index"
                  class="pa-1"
                >
                  <v-card elevation="0" style="border-radius: 2px">
                    <v-card-text class="px-4 py-2">
                      <span
                        class="text_color--text text-capitalize text-center text-caption font-weight-bold d-flex justify-center"
                      >
                        {{ key.replace(/_/g, "  ") }}
                      </span>
                      <div
                        class="mt-2 d-flex align-center justify-space-around"
                      >
                        <v-icon :color="customerAnalyticsColor[key]">
                          {{ customerAnalyticsIcon[key] }}</v-icon
                        >

                        <span class="text-caption">
                          <h3>{{ value }}</h3>
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div class="px-2">
              <v-card elevation="0" v-if="!isVisibleOrderDetails">
                <v-row no-gutters>
                  <v-col cols="6" class="d-flex align-center pl-2">
                    <h4 class="text-capitalize text-subtitle-2">
                      {{ orderModule.orderPlural }}
                    </h4>
                  </v-col>
                  <v-col cols="6">
                    <v-tabs v-model="tab" right>
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Today
                        </h4>
                      </v-tab>

                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          last 7 days
                        </h4>
                      </v-tab>
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Next 7 days
                        </h4>
                      </v-tab>
                    </v-tabs>
                  </v-col>
                  <v-col cols="12" style="height: calc(100vh - 355px)">
                    <AgGridVue
                      @grid-ready="gridReady"
                      :grid-options="gridOptions"
                      :column-defs="columnDefs"
                      :default-col-def="defaultColDef"
                      :row-data="orderList"
                      :context="context"
                      style="width: 100%; height: calc(100vh - 355px)"
                      class="ag-theme-balham px-4 pt-4"
                    >
                    </AgGridVue>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end">
                    <Pagination
                      :pageNo="pageNo"
                      :totalItems="totalCount"
                      :pageSize="itemsPerPage"
                      @itemsPerPageChange="itemsPerPageChange"
                      @prevPage="prevPage"
                      @nextPage="nextPage"
                    />
                  </v-col>
                </v-row>
              </v-card>
              <v-card
                elevation="0"
                v-else
                style="height: calc(100vh - 245px)"
                class="ml-2"
              >
                <v-row no-gutters>
                  <v-col cols="6" class="d-flex align-center pl-2">
                    <v-icon
                      small
                      @click="isVisibleOrderDetails = false"
                      class="mx-3"
                      >mdi-arrow-left</v-icon
                    >
                    <h4 class="text-capitalize text-subtitle-2">
                      {{ orderModule.order }} details
                    </h4>
                  </v-col>
                  <v-col cols="6">
                    <v-tabs v-model="tabDetails" right>
                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Details
                        </h4>
                      </v-tab>

                      <v-tab>
                        <h4
                          class="text-caption font-weight-bold app-driver-font-tab"
                        >
                          Logs
                        </h4>
                      </v-tab>
                    </v-tabs>
                  </v-col>
                  <v-col cols="12" class="pa-0 mx-0 background_color">
                    <v-tabs-items v-model="tabDetails" class="">
                      <v-tab-item
                        class="background_color"
                        style="height: calc(100vh - 290px)"
                      >
                        <v-card
                          elevation="0"
                          class="card-box-shadow pa-0 mb-8 rounded-lg"
                        >
                          <v-row
                            class="px-3"
                            v-if="orderDetail && orderDetail.order_details"
                          >
                            <v-col cols="6" class="d-flex align-center">
                              <h2
                                class="mr-2"
                                v-if="
                                  orderDetail.order_details.reference_number
                                "
                              >
                                {{ orderDetail.order_details.reference_number }}
                              </h2>
                              <v-chip
                                class="mr-1 text-capitalize font-weight-bold"
                                x-small
                                v-if="orderDetail.order_details.verbose_status"
                                :class="
                                  $helper.getOrderStatusColor(
                                    orderDetail.order_details.verbose_status,
                                    true
                                  )
                                "
                              >
                                {{ orderDetail.order_details.verbose_status }}
                              </v-chip>
                            </v-col>
                            <v-col
                              cols="6"
                              class="text-right d-flex justify-end"
                              v-if="orderDetail.order_details.branch"
                            >
                              <div class="mr-2">
                                <TripTooltipWithIcon
                                  icon="mdi-package-variant-closed"
                                  :text="orderDetail.order_details.branch"
                                  :label="`${configurationModule.branch} Name`"
                                />
                              </div>
                              <div
                                class="mr-2"
                                v-if="orderDetail.order_details.order_date"
                              >
                                <TripTooltipWithIcon
                                  icon="mdi-calendar-range"
                                  :text="orderDetail.order_details.order_date"
                                  :label="`${tripModule.trip} Date`"
                                />
                              </div>
                            </v-col>
                          </v-row>
                        </v-card>

                        <v-card elevation="0" class="card-box-shadow pa-0 mb-4">
                          <v-row
                            class="px-3 py-2"
                            no-gutters
                            v-if="orderDetail.customer_details"
                          >
                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              title="View Customer Details"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.customer_name
                              "
                              @click="
                                redirectCustomerDetails(
                                  orderDetail.customer_details
                                )
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-account"
                                :text="
                                  orderDetail.customer_details.customer_name
                                "
                                :label="`${customerModule.customer} Name`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              title="View Customer Details"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.customer_number
                              "
                              @click="
                                redirectCustomerDetails(
                                  orderDetail.customer_details
                                )
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-phone"
                                :text="
                                  orderDetail.customer_details.customer_number
                                "
                                :label="`${customerModule.customer} number`"
                              />
                            </v-col>

                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              title="View Customer Details"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.contact_person
                              "
                              @click="
                                redirectCustomerDetails(
                                  orderDetail.customer_details
                                )
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-account-card"
                                :text="
                                  orderDetail.customer_details.contact_person
                                "
                                label="contact person"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              title="View Customer Details"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.contact_email
                              "
                              @click="
                                redirectCustomerDetails(
                                  orderDetail.customer_details
                                )
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-email"
                                :text="
                                  orderDetail.customer_details.contact_email
                                "
                                :label="`${customerModule.customer} email`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1 hover-pointe"
                              title="View Customer Details"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.from_time
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-clock-time-five-outline"
                                :text="orderDetail.customer_details.from_time"
                                :label="`${customerModule.customer} from time`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.customer_details &&
                                orderDetail.customer_details.to_time
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-clock-time-four"
                                :text="orderDetail.customer_details.to_time"
                                :label="`${customerModule.customer} to time`"
                              />
                            </v-col>

                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.order_details &&
                                orderDetail.order_details.weight
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-weight"
                                :text="orderDetail.order_details.weight"
                                :label="`${orderModule.order} weight`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.order_details &&
                                orderDetail.order_details.volume
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-cube"
                                :text="orderDetail.order_details.volume"
                                :label="`${orderModule.order} volume`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.order_details &&
                                orderDetail.order_details.total_items
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-information"
                                :text="orderDetail.order_details.total_items"
                                :label="`${orderModule.order} items`"
                              />
                            </v-col>
                            <v-col
                              cols="3"
                              class="pb-1"
                              v-if="
                                orderDetail.order_details &&
                                orderDetail.order_details.total_quantity
                              "
                            >
                              <TripTooltipWithIcon
                                icon="mdi-archive"
                                :text="orderDetail.order_details.total_quantity"
                                :label="`${orderModule.order} total quantity`"
                              />
                            </v-col>
                          </v-row>
                        </v-card>

                        <v-card elevation="0">
                          <OrderItems
                            :orderId="orderDetail.id"
                            :status="orderDetail.status"
                          />
                        </v-card>
                      </v-tab-item>

                      <v-tab-item>
                        <Logs :logs="OrderLogs" />
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <!-- <div>3</div> -->
          </section>
        </v-col>
        <v-col cols="12" md="3" lg="3" class="pa-1">
          <div>
            <v-card class="card-box-shadow mb-3" elevation="0">
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Logs</h6>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="overflow-y-auto"
                style="height: calc(100vh - 190px)"
              >
                <Logs :logs="customerLogs" />
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </template>
    <template #dialogs>
      <CustomerForm
        :edit-mode="true"
        v-model="showCustomerForm"
        :customerID="customerDetails.id"
        @refreshList="getAllData()"
      />
    </template>
  </BaseDetails>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/BaseComponents/Pagination.vue";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";
import DialogBase from "@/components/BaseComponents/DialogBase.vue";
import Logs from "@/components/BaseComponents/Logs.vue";
import BaseSmallTripDetail from "@/components/BaseComponents/BaseSmallTripDetail.vue";
import driverImage from "@/assets/profile.jpg";
import OrderTooltipWithIcon from "@/components/ModuleBasedComponents/Order/OrderTooltipWithIcon.vue";
import CustomerOrderDetailsButton from "@/components/Button/CustomerOrderDetailsButton.vue";
import OrderItems from "@/components/ModuleBasedComponents/Order/OrderItems.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import {
  configurationModule,
  customerModule,
  orderModule,
  tripModule,
  tripPlanningModule,
} from "@/utils/moduleMapping";
import { getDateTime, returnToday } from "@/utils/functions";
import BaseDetails from "@/components/LayoutComponents/BaseDetails.vue";
import CustomerForm from "@/components/ModuleBasedComponents/Customer/CustomerForm.vue";

export default {
  components: {
    Pagination,
    BaseDetailLayout,
    DialogBase,
    Logs,
    BaseSmallTripDetail,
    OrderTooltipWithIcon,
    AgGridVue,
    CustomerOrderDetailsButton,
    OrderItems,
    TripTooltipWithIcon,
    BaseDetails,
    CustomerForm,
  },
  data() {
    return {
      tripPlanningModule,
      configurationModule,
      orderModule,
      tripModule,
      customerModule,
      driverImage,
      tab: 0,
      showCustomerForm: false,
      tabDetails: 0,
      customerDetail: {
        customer_details: {},
        customer_analytics: {
          orders_in_last_days: 10,
          total_orders: 36,
          total_addresses: 2832,
          avg_order_of_week: 43,
          avg_daily_address: 23,
        },
        assigned_tag: [
          {
            name: "Dubai",
            id: 1,
          },
          {
            name: "Kuwait",
            id: 2,
          },
          {
            name: "Oman",
            id: 3,
          },
        ],
      },
      customerAnalyticsColor: {
        avg_daily_address: "pickup",
        avg_order_of_week: "trip_active",
        total_orders: "on_hold",
        total_addresses: "green",
        orders_in_last_days: "failed",
      },
      customerAnalyticsIcon: {
        avg_daily_address: "mdi-archive-check",
        avg_order_of_week: "mdi-archive-star",
        total_orders: "mdi-archive",
        total_addresses: "mdi-map-marker",
        orders_in_last_days: "mdi-archive-clock",
      },

      showMore: false,
      driverDocuments: [],
      itemsPerPage: 10,
      pageNo: 1,
      addressTab: 1,
      defaultColDef: {
        lockPosition: true,
        flex: 1,
        resizable: true,
        sortable: true,
        autoHeight: true,
        cellStyle: {
          "text-overflow": "ellipsis",
          "white-space": "nowrap",
          overflow: "hidden",
          display: "block",
        },
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        headerHeight: 40,
        rowHeight: 40,
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },

      customerLogs: [],
      OrderLogs: [],
      customerDetails: {},
      isDriverLogsScrollable: true,
      driverZoneLogs: [],

      showDocumentDialog: false,
      customerLogsTotalCount: 0,
      isDriverZoneLogsScrollable: true,
      totalCount: 0,
      documentUploadFormDialog: false,
      orderList: [],
      columnDefs: [
        {
          headerName: "reference number",
          headerTooltip: "Reference Number",
          field: "reference_number",
          pinned: "left",
          minWidth: 200,
        },
        {
          headerName: "Order Segment",
          headerTooltip: "Order Segment",
          field: "order_segment",
        },
        {
          headerName: "address",
          headerTooltip: "Address",
          field: "address",
        },
        {
          headerName: "customer name",
          field: "customer_name",
        },
        {
          headerName: "contact number",
          field: "contact_number",
        },
        {
          headerName: "order status",
          field: "verbose_status",
          cellClass: "text-capitalize",
        },
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          width: 100,
          sortable: false,
          cellRenderer: "CustomerOrderDetailsButton",
        },
      ],
      permissions: null,
      orderDetail: {},
      isVisibleOrderDetails: false,
    };
  },
  watch: {
    tabDetails(val) {
      if (val == 1) {
        this.getOrderLogs();
      }
    },
    tab() {
      this.getOrderList();
    },
  },
  computed: {
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.itemsPerPage);
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    getOrderList() {
      let params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        customer: this.$route.params.id,
        segment: "sales",
      };
      if (this.tab == 0) {
        params = {
          ...params,
          execution_date: returnToday(),
        };
      } else if (this.tab == 1) {
        let startDate = new Date(returnToday());
        startDate.setDate(startDate.getDate() - 7);
        params = {
          ...params,
          from_date: getDateTime(startDate),
          to_date: returnToday(),
        };
      } else if (this.tab == 2) {
        let endDate = new Date(returnToday());
        endDate.setDate(endDate.getDate() + 7);
        params = {
          ...params,
          from_date: returnToday(),
          to_date: getDateTime(endDate),
        };
      }

      if (this.search) {
        params.search = this.search;
      }

      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.orderList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },

    itemsPerPageChange(value) {
      this.pageNo = 1;
      this.itemsPerPage = value;
      this.getOrderList();
    },
    nextPage() {
      this.pageNo++;
      this.getOrderList();
    },
    prevPage() {
      this.pageNo--;
      this.getOrderList();
    },
    gridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    onScroll() {
      this.scrollInvoked++;
    },
    onDriverLogsScroll(e) {
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll < 4 && this.isDriverLogsScrollable) {
        this.isDriverLogsScrollable = false;
        this.getDriverLogs();
      }
    },
    getCustomerTag(params = {}) {
      // params = {
      //   ...params,
      //   driver: this.$route.params.id,
      //   limit: this.itemsPerPage,
      //   offset: this.offset,
      // };
      // bus.$emit("showLoader", true);
      // this.$api.driver
      //   .getCustomerTag(params)
      //   .then((res) => {
      //     bus.$emit("showLoader", false);
      //     this.driverDocuments = res.data;
      //     this.totalCount = res.count;
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //     bus.$emit("showLoader", false);
      //   });
    },
    getDriverView(params = {}) {
      // bus.$emit("showLoader", true);
      // this.$api.driver
      //   .getDriverView(params)
      //   .then((res) => {
      //     this.customerDetail = res.data;
      //     bus.$emit("showLoader", false);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     bus.$emit("showLoader", false);
      //   });
    },
    getOrderDetail(id) {
      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderView(id)
        .then((res) => {
          this.orderDetail = res.data;
          this.isVisibleOrderDetails = true;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    deleteDriverZones(id, index) {
      // this.$root
      //   .$confirm("Delete?", "Are you sure you want to delete this zone?", {
      //     color: "error",
      //   })
      //   .then((confirm) => {
      //     if (confirm) {
      //       this.$api.driver
      //         .deleteDriverZones(id)
      //         .then((res) => {
      //           console.log("calling");
      //           bus.$emit("showToastMessage", {
      //             message: "driver assigned zone removed successfully",
      //             color: "success",
      //           });
      //           if (
      //             this.customerDetail &&
      //             this.customerDetail.assigned_zones &&
      //             this.customerDetail.assigned_zones.length > 0
      //           ) {
      //             this.customerDetail.assigned_zones.splice(index, 1);
      //           }
      //         })
      //         .catch((err) => console.log(err));
      //     }
      //   });
    },
    getCustomerDetails() {
      bus.$emit("showLoader", true);
      this.$api.customer
        .getCustomerObject(this.$route.params.id)
        .then((res) => {
          this.customerDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getCustomerLogs() {
      bus.$emit("showLoader", true);
      let params = {
        customer: this.$route.params.id,
        limit: "all",
      };
      this.$api.logs
        .getCustomerAddressLogs(params)
        .then((res) => {
          this.customerLogs = res.data;
          this.openCustomerLogDialog = true;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderLogs() {
      const params = {
        order: this.orderDetail.id,
        limit: "all",
      };
      this.$api.logs
        .getOrderLogs(params)
        .then((res) => {
          this.OrderLogs = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAllData() {
      this.getCustomerLogs();
      this.getCustomerDetails();
      this.getOrderList();
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      // this.getDriverView(this.$route.params.id);
      this.getCustomerLogs();
      this.getCustomerDetails();
      this.getOrderList();
      // this.getCustomerTag();
    }
  },
  created() {
    this.permissions = this.$permissions.getPermission("customer");
  },
};
</script>

<style scoped>
.order-list-height {
  height: calc(100vh - 630px);
}
.app-driver-font-tab {
  font-family: roboto;
  text-transform: capitalize;
  letter-spacing: 0.1px;
}
.main-customer-layout {
  height: 100%;
}
.main-customer-layout .column-grid {
  display: grid;
  grid-template-columns: 400px 1fr 400px;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
}
.main-customer-layout .column-grid .column-grid-content {
  display: grid;
  grid-template-rows: 100px 1fr;
  grid-column-gap: 8px;
  height: calc(100vh - 130px);
}
/* .column-grid-content > div {
  border: 1px solid red;
} */
.card-vehicle-analytic-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 9px;
}
</style>
